import React from "react";

const Currency = ({ row }) => {
  return (
    <div>
      {row?.currency?.map((c) => (
        <div style={{ marginBottom: "10px" }}>{c}</div>
      ))}
    </div>
  );
};

export default Currency;
